import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_5 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_6 = {
  class: "btn btn-outline-secondary",
  style: {"padding":"0.7em 2em"}
}
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_10 = { class: "table table-bordered align-middle" }
const _hoisted_11 = {
  key: 0,
  style: {"width":"120px"}
}
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "d-flex justify-content-between align-items-center mt-3" }
const _hoisted_16 = { class: "text-muted" }
const _hoisted_17 = {
  key: 0,
  class: "btn btn-primary"
}
const _hoisted_18 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_19 = {
  key: 1,
  class: "alert alert-danger mt-3"
}
const _hoisted_20 = {
  key: 2,
  class: "alert alert-danger mt-3"
}

import { computed, ref, onMounted, watch, type Ref } from 'vue'
    import { onBeforeRouteLeave, useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import ProjectNavigation from '@Quest/ProjectPlans/Components/ProjectNavigation.vue'

    import { useProjectPhasesQueryV1 } from '@Quest/ProjectPlans/queries-vue-composables'
    import { useSetupPhasesCommandV1, useClearPhasesCommandV1, useSetPhaseDurationCommandV1 } from '@Quest/ProjectPlans/commands-vue-composables'

    import type { ProjectPhasesReadModel } from '@Quest/ProjectPlans/readmodels'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectPhasesPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const projectId = computed(() => String(route.params.projectId ?? ''))
    const planId = ref<string | null>(null)

    const projectPlanName = computed<string>(() => rm.value?.ProjectPlanName ?? '')

    const {
        runProjectPhasesQueryV1,
        modelProjectPhasesQueryV1
    } = useProjectPhasesQueryV1(workspaceId, tchProjectId, projectId, planId)

    const rm = modelProjectPhasesQueryV1 as Ref<ProjectPhasesReadModel | null>

    const userId = computed(() => rm.value?.UserId)
    const portfolioId = computed(() => rm.value?.PortfolioId ?? '')

    const {
        invokeSetupPhasesCommandV1,
        validationErrorsSetupPhasesCommandV1,
        onSucceedSetupPhasesCommandV1
    } = useSetupPhasesCommandV1(userId, workspaceId, portfolioId, projectId, planId)

    const {
        invokeClearPhasesCommandV1,
        validationErrorsClearPhasesCommandV1,
        onSucceedClearPhasesCommandV1
    } = useClearPhasesCommandV1(userId, workspaceId, portfolioId, projectId, planId)

    const {
        invokeSetPhaseDurationCommandV1,
        validationErrorsSetPhaseDurationCommandV1,
        onSucceedSetPhaseDurationCommandV1
    } = useSetPhaseDurationCommandV1(userId, workspaceId, portfolioId, projectId, planId)

    const durations = ref<Record<string, number>>({})

    const orderedPhases = computed(() =>
    {
        if (!rm.value) return []
        return [...rm.value.Phases].sort((a, b) => a.OrderValue - b.OrderValue)
    })

    const totalMonths = computed(() =>
    {
        return Object.values(durations.value).reduce((a, b) => a + (b ?? 0), 0)
    })

    function setupPhases()
    {
        const map: Record<string, number> = {}

        for (const p of orderedPhases.value)
        {
            const duration = durations.value[p.Id] ?? 0

            if (duration > 0)
                map[p.Id] = duration
        }

        invokeSetupPhasesCommandV1({
            phaseDurations: map
        })
    }

    function setPhaseDuration(phaseId: string)
    {

        invokeSetPhaseDurationCommandV1({
            projectPhaseDefinitionId: phaseId,
            durationInMonths: durations.value[phaseId] ?? 0
        })
    }

    function clearPhases()
    {
        invokeClearPhasesCommandV1()
    }

    onMounted(() =>
    {

        document.title = 'Phases | TransparentChoice'

        planId.value = route.params.planId
            ? String(route.params.planId)
            : null

        runProjectPhasesQueryV1()
    })

    watch(rm, (value) =>
    {

        if (!value) return

        planId.value = value.ProjectPlanId

        const map: Record<string, number> = {}

        for (const p of value.Phases)
        {
            map[p.Id] = p.DurationInMonths ?? 0
        }

        durations.value = map
    })

    onSucceedSetupPhasesCommandV1(() => runProjectPhasesQueryV1())
    onSucceedClearPhasesCommandV1(() => runProjectPhasesQueryV1())
    onSucceedSetPhaseDurationCommandV1(() => runProjectPhasesQueryV1())


return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(rm).ProjectName), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Meta data ", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, `/#/portfolio/alternative/dashboard/${workspaceId.value}/${tchProjectId.value}/${projectId.value}`]
              ])
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createVNode(ProjectNavigation, {
            ActivePage: "phases",
            class: "mt-4",
            workspaceId: workspaceId.value,
            tchProjectId: tchProjectId.value,
            projectId: projectId.value,
            planId: planId.value
          }, null, 8 /* PROPS */, ["workspaceId", "tchProjectId", "projectId", "planId"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(setupPhases, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-0" }, "Project phases", -1 /* CACHED */)),
                  (_unref(rm).HasPhaseDurations)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-outline-danger",
                        onClick: clearPhases
                      }, " Clear phases "))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[2] || (_cache[2] = _createElementVNode("th", null, "Phase", -1 /* CACHED */)),
                      _cache[3] || (_cache[3] = _createElementVNode("th", { style: {"width":"160px"} }, "Duration (months)", -1 /* CACHED */)),
                      (_unref(rm).HasPhaseDurations)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_11))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedPhases.value, (p) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: p.Id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            max: "240",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((durations.value[p.Id]) = $event)
                          }, null, 8 /* PROPS */, _hoisted_12), [
                            [
                              _vModelText,
                              durations.value[p.Id],
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        (_unref(rm).HasPhaseDurations)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-outline-primary btn-sm",
                                onClick: ($event: any) => (setPhaseDuration(p.Id))
                              }, " Save ", 8 /* PROPS */, _hoisted_14)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, " Total duration: " + _toDisplayString(totalMonths.value) + " months ", 1 /* TEXT */),
                  (!_unref(rm).HasPhaseDurations)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_17, " Setup phases "))
                    : _createCommentVNode("v-if", true)
                ])
              ], 32 /* NEED_HYDRATION */)
            ])
          ]),
          (_unref(validationErrorsSetupPhasesCommandV1)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(validationErrorsSetupPhasesCommandV1), (e) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: e.Message
                  }, _toDisplayString(e.Message), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validationErrorsSetPhaseDurationCommandV1)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(validationErrorsSetPhaseDurationCommandV1), (e) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: e.Message
                  }, _toDisplayString(e.Message), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validationErrorsClearPhasesCommandV1)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(validationErrorsClearPhasesCommandV1), (e) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: e.Message
                  }, _toDisplayString(e.Message), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})